import { DataGrid, DataGridProps,GridValidRowModel} from '@mui/x-data-grid';

interface DataGridComponent {
    <R extends GridValidRowModel = any>(props: DataGridProps<R> & React.RefAttributes<HTMLDivElement>): JSX.Element;
    propTypes?: any;
}

export const GenericTable:DataGridComponent = DataGrid;
export {};